import React from 'react';
import { Card, CardContent } from '@/app/_components/core/card';
import { Copytext } from '@/app/_components/core/copytext';
import { SmartLink } from '@/app/_components/core/smart-link';
import { CardSectionElement } from '@/app/_components/shared/card-section/card-section.types';
import { cn } from '@/app/_lib/utils';

interface HighlightCardProps {
  card: CardSectionElement;
  trackId?: string;
}

export function HighlightCard({ card, trackId }: HighlightCardProps) {

  const cardContent = (
    <CardContent className="flex h-full flex-col justify-start gap-2 p-6">
      {card.title && (
        <h3 className="mb-2 line-clamp-3 text-xl font-extrabold wrap-break-word">
          {card.title}
        </h3>
      )}
      {card.text && (
        <Copytext variant="book-muted" className="mb-0 wrap-break-word">
          {card.text}
        </Copytext>
      )}
    </CardContent>
  );

  if (card.linkUrl) {
    return (
      <Card
        variant="elevated"
        className={cn('p-0 transition-shadow hover:shadow-lg')}
        asChild
      >
        <SmartLink
          href={card.linkUrl}
          target={card.linkTarget}
          download={card.download}
          data-track-id={trackId}
        >
          {cardContent}
        </SmartLink>
      </Card>
    );
  }

  return (
    <Card variant="elevated" className="p-0">
      {cardContent}
    </Card>
  );
}
